"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RcReactTableSelectInput = props => /*#__PURE__*/_react.default.createElement("label", {
  className: "checkbox pb-4 ml-1 is-pulled-left"
}, /*#__PURE__*/_react.default.createElement("input", {
  type: props.selectType || 'checkbox',
  "aria-label": `${props.checked ? 'Un-select' : 'Select'} row with id:${props.id}`,
  checked: props.checked,
  id: props.id,
  onClick: e => {
    const {
      shiftKey
    } = e;
    e.stopPropagation();
    props.onClick(props.id, shiftKey, props.row);
  },
  onChange: () => {}
}), /*#__PURE__*/_react.default.createElement("span", null));
RcReactTableSelectInput.propTypes = {
  id: _propTypes.default.string,
  selectType: _propTypes.default.string,
  checked: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  row: _propTypes.default.any
};
var _default = exports.default = RcReactTableSelectInput;
//# sourceMappingURL=RcReactTableSelectInput.js.map